import React, { useMemo } from 'react';
import('./style.scss');
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import logo from '../../../assets/images/yi_logo.gif';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  toJewishDate,
  formatJewishDate,
  toHebrewJewishDate,
  formatJewishDateInHebrew
} from 'jewish-date';
import Footer from './Footer';

const Layout = () => {
  const location = useLocation();

  const openAnnouncement = () => {
    fetch('/api/announcement')
      .then(response => response.json())
      .then(payload => {
        const url = payload?.weekly_announcement?.url;
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
      });
  };

  const donateUrl = 'https://youngisrael-stl.easyshul.com/donation';

  const primaryNavLinks = [
    { to: '/about', label: 'About' },
    { to: '/davening', label: 'Davening' },
    { to: '/learning', label: 'Learning' },
    { to: '/events', label: 'Events' },
    { to: '/community', label: 'Community' },
    { href: donateUrl, label: 'Donate', external: true }
  ];

  const mobileQuickLinks = [
    {
      key: 'announcements',
      label: 'Announcements',
      onClick: openAnnouncement
    },
    {
      key: 'contact',
      label: 'Contact',
      href: '/about/contact'
    }
  ];

  const activeNavKey = useMemo(() => {
    if (location.pathname === '/') {
      return null;
    }

    const matchingLink = primaryNavLinks.find(
      ({ to }) => to && location.pathname.startsWith(to)
    );

    return matchingLink?.to ?? null;
  }, [location.pathname]);

  return (
    <>
      <div
        className='top-bar container-fluid '
        style={{ backgroundColor: '#344A5D' }}
      >
        <Container>
          <Row className='text-white py-3'>
            <Col className='col-lg-4 col-md-4 col-xs-12 col-sm-12 d-none d-lg-block'>
              <span>
                {new Date().toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </span>{' '}
              <span
                style={{ whiteSpace: 'nowrap' }}
                className='border-start ms-2 ps-2'
              >
                {formatJewishDate(toJewishDate(new Date()))}
              </span>
            </Col>
            <Col className='text-end col-lg-8 col-md-8 col-xs-12 col-sm-12 d-none d-lg-block'>
              <span style={{ whiteSpace: 'nowrap' }}>314-727-1880</span>{' '}
              <span className='border-start ms-2 ps-2'>
                <a
                  id='announcement-link'
                  style={{ cursor: 'pointer' }}
                  onClick={openAnnouncement}
                >
                  ANNOUNCEMENTS
                </a>
              </span>
              {/* <span className='border-start ms-2 ps-2'>
                <a href='/calendar'>CALENDAR</a>
              </span> */}
              <span className='border-start ms-2 ps-2'>
                <a href='/about/contact'>CONTACT</a>
              </span>
              <span className='border-start ms-2 ps-2'>
                <a href={donateUrl} target='_blank' rel='noopener noreferrer'>
                  DONATE
                </a>
              </span>
            </Col>
          </Row>
        </Container>
      </div>
      <Navbar
        collapseOnSelect
        expand='lg'
        style={{ fontSize: '1.2rem', color: '#006494' }}
      >
        {' '}
        <Container>
          <Navbar.Brand to='/' as={NavLink}>
            <img src={logo} className='ps-3' style={{ height: '100px' }} />
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className='justify-content-end'>
            <Nav
              className='ms-auto flex-lg-row flex-column align-items-lg-center'
              activeKey={activeNavKey}
            >
              {primaryNavLinks.map(({ to, href, label, external }) =>
                external ? (
                  <Nav.Link
                    key={href}
                    href={href}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='py-2 py-lg-0'
                  >
                    {label}
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={NavLink}
                    to={to}
                    href={to}
                    key={to}
                    eventKey={to}
                    className='py-2 py-lg-0'
                  >
                    {label}
                  </Nav.Link>
                )
              )}
            </Nav>
            <Nav className='ms-auto d-lg-none flex-column mt-3'>
              {mobileQuickLinks.map(({ key, label, href, onClick }) => (
                <Nav.Link
                  key={key}
                  href={href}
                  onClick={onClick}
                  className='py-2'
                >
                  {label}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Outlet />
      <Footer />
      {/* <h1>Footer</h1> */}
    </>
  );
};

export default Layout;
